import CommonApp from '../../app.js';
import {userProfileManager} from '../../../util/user-profile-manager';
import {configManager} from '../../../util/config-manager/config-manager';
import {cookieUtil} from '../../../util/cookie-util.js';
import TaxIdService from '../tax-id-service.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager';

CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
CommonApp.module.service('userProfileManager', function() {
    return userProfileManager; 
});
CommonApp.module.service('configManager', function() {
    return configManager; 
});
CommonApp.module.service('cookieUtil', function() {
    return cookieUtil; 
});

TaxIdService.$inject = ['$http', '$q', 'configManager', 'userProfileManager', 'cookieUtil', 'AccountConfigManager'];
CommonApp.module.service('taxIdService', TaxIdService);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/adapters/tax-id-service-adapter.js
// module id = 273
// module chunks = 0